import React, { useState } from 'react';
import './Portfolio.css';

function Portfolio() {
  const [activeCategory, setActiveCategory] = useState('all');
  const [selectedPattern, setSelectedPattern] = useState(null);

  const categories = [
    { id: 'all', name: 'All Patterns' },
    { id: 'floral', name: 'Floral' },
    { id: 'geometric', name: 'Geometric' },
    { id: 'nature', name: 'Nature' },
    { id: 'abstract', name: 'Abstract' },
  ];

  // Pattern collection with actual images
  const patterns = [
    {
      id: 1,
      title: 'Blue Grass',
      category: 'floral',
      description: 'Elegant grass stems in classic blue',
      color: '#C5D5E4',
      image: '/images/patterns/bluegrassLOGO.png'
    },
    {
      id: 2,
      title: 'Blue Grass Navy',
      category: 'floral',
      description: 'Deep navy variation with graceful stems',
      color: '#2B3A4A',
      image: '/images/patterns/bluegrassnavyLOGO.png'
    },
    {
      id: 3,
      title: 'Geometric Thistle',
      category: 'geometric',
      description: 'Modern geometric interpretation of thistles',
      color: '#D2D5E1',
      image: '/images/patterns/geometricthistleLOGO.png'
    },
    {
      id: 4,
      title: 'Stems on Blue',
      category: 'floral',
      description: 'Botanical stems on serene blue background',
      color: '#C5D5E4',
      image: '/images/patterns/stemsonBLUELOGO.png'
    },
    {
      id: 5,
      title: 'Stems on Terracotta',
      category: 'floral',
      description: 'Warm terracotta with decorative stems',
      color: '#E8A87C',
      image: '/images/patterns/StemsonTerracottaLOGO.png'
    },
    {
      id: 6,
      title: 'Deco Stems',
      category: 'geometric',
      description: 'Art deco inspired stem patterns',
      color: '#D4D5C4',
      image: '/images/patterns/DECOSTEMSLOGO.png'
    },
    {
      id: 7,
      title: 'Dandelions',
      category: 'floral',
      description: 'Whimsical dandelion seed heads',
      color: '#E8D5C4',
      image: '/images/patterns/dandilionslogo.png'
    },
    {
      id: 8,
      title: 'Forest Floor',
      category: 'nature',
      description: 'Inspired by woodland ground cover',
      color: '#D4E4D0',
      image: '/images/patterns/forestfloorlogo.png'
    },
    {
      id: 9,
      title: 'Fossils',
      category: 'nature',
      description: 'Ancient fossils and natural history',
      color: '#E1D4C4',
      image: '/images/patterns/fossilslogo.png'
    },
    {
      id: 10,
      title: 'Herbs',
      category: 'floral',
      description: 'Fresh herb garden pattern',
      color: '#D4E4D0',
      image: '/images/patterns/herbslogo.png'
    },
    {
      id: 11,
      title: 'Jazz Music',
      category: 'abstract',
      description: 'Rhythmic pattern inspired by jazz',
      color: '#E4D4DC',
      image: '/images/patterns/jazzmusiclogo.png'
    },
    {
      id: 12,
      title: 'Leaves of Three',
      category: 'nature',
      description: 'Botanical leaf study pattern',
      color: '#D4E4D0',
      image: '/images/patterns/leavesofthreeletthembelogo.png'
    },
    {
      id: 13,
      title: 'Summer Picnic',
      category: 'abstract',
      description: 'Cheerful picnic-themed design',
      color: '#F4E1D2',
      image: '/images/patterns/summerpicniclogo.png'
    },
    {
      id: 14,
      title: 'Art Supplies',
      category: 'abstract',
      description: 'Creative tools and materials',
      color: '#E4D4DC',
      image: '/images/patterns/artsupplieslogo.png'
    },
    {
      id: 15,
      title: 'Celebrate Baltimore Tea Towel',
      category: 'abstract',
      description: 'Baltimore-themed decorative design',
      color: '#E8D5C4',
      image: '/images/patterns/CelebrateBaltimoreteatowellogo.png'
    },
    {
      id: 16,
      title: 'Postcard Calendar',
      category: 'abstract',
      description: 'Vintage postcard collection',
      color: '#F4E1D2',
      image: '/images/patterns/POSTCARDCALlogo.png'
    },
    {
      id: 17,
      title: 'USA Stamps',
      category: 'abstract',
      description: 'American stamp collection design',
      color: '#E8D5C4',
      image: '/images/patterns/USAstampslogo.png'
    },
    {
      id: 18,
      title: 'Cities',
      category: 'abstract',
      description: 'Urban skyline illustrations',
      color: '#D2D5E1',
      image: '/images/patterns/citieslogo.png'
    },
    {
      id: 19,
      title: 'Countdown to Christmas',
      category: 'abstract',
      description: 'Festive holiday countdown',
      color: '#E4D4DC',
      image: '/images/patterns/countdowntochristmaslogo.png'
    },
    {
      id: 20,
      title: 'Pickle Calendar',
      category: 'abstract',
      description: 'Playful pickle-themed calendar',
      color: '#D4E4D0',
      image: '/images/patterns/picklecalendarafdesignLOGO.png'
    },
    {
      id: 21,
      title: 'Picnic',
      category: 'abstract',
      description: 'Outdoor dining essentials',
      color: '#F4E1D2',
      image: '/images/patterns/picnicLOGO.png'
    },
    {
      id: 22,
      title: 'Sewing Table 2023',
      category: 'abstract',
      description: 'Sewing and crafting tools',
      color: '#E8D5C4',
      image: '/images/patterns/sewingtable2023logo.png'
    },
    {
      id: 23,
      title: "S'mores Tea Towel",
      category: 'abstract',
      description: 'Campfire treats design',
      color: '#E1D4C4',
      image: '/images/patterns/smoresteatowellogo.png'
    },
    {
      id: 24,
      title: 'Nature Trail',
      category: 'nature',
      description: 'Woodland path exploration',
      color: '#D4E4D0',
      image: '/images/patterns/NaturetrailLOGO.png'
    },
    {
      id: 25,
      title: 'Grumpy Toad',
      category: 'nature',
      description: 'Whimsical toad character',
      color: '#D4E4D0',
      image: '/images/patterns/grumpytoadLOGO.png'
    },
    {
      id: 26,
      title: 'Toadstools and Butterflies',
      category: 'nature',
      description: 'Magical forest creatures',
      color: '#E4D4DC',
      image: '/images/patterns/toadstoolsandbutteriesLOGO.png'
    },
  ];

  const filteredPatterns = activeCategory === 'all' 
    ? patterns 
    : patterns.filter(pattern => pattern.category === activeCategory);

  return (
    <div className="portfolio">
      <div className="portfolio-header">
        <h1>Pattern Portfolio</h1>
        <p>A curated collection of contemporary pattern designs</p>
      </div>

      <div className="category-filter">
        {categories.map(category => (
          <button
            key={category.id}
            className={`filter-btn ${activeCategory === category.id ? 'active' : ''}`}
            onClick={() => setActiveCategory(category.id)}
          >
            {category.name}
          </button>
        ))}
      </div>
      <div className="portfolio-grid">
        {filteredPatterns.map(pattern => (
          <div key={pattern.id} className="pattern-card" onClick={() => setSelectedPattern(pattern)}>
            <div 
              className="pattern-image" 
              style={{ 
                backgroundColor: pattern.color,
                backgroundImage: pattern.image ? `url(${pattern.image})` : 'none',
                backgroundSize: 'cover',
                backgroundPosition: 'center'
              }}
            >
              <div className="pattern-overlay">
                <h3>{pattern.title}</h3>
                <p>{pattern.description}</p>
              </div>
            </div>
            <div className="pattern-info">
              <h4>{pattern.title}</h4>
              <span className="pattern-category">{pattern.category}</span>
            </div>
          </div>
        ))}
      </div>

      {selectedPattern && (
        <div className="modal-overlay" onClick={() => setSelectedPattern(null)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={() => setSelectedPattern(null)}>
              ×
            </button>
            <div className="modal-image-container">
              <img 
                src={selectedPattern.image} 
                alt={selectedPattern.title}
                className="modal-image"
              />
            </div>
            <div className="modal-info">
              <h2>{selectedPattern.title}</h2>
              <p>{selectedPattern.description}</p>
              <a 
                href="https://www.spoonflower.com/profiles/sarahparr" 
                target="_blank" 
                rel="noopener noreferrer"
                className="spoonflower-button"
              >
                View on Spoonflower
              </a>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Portfolio;
